import { makeStyles } from '@material-ui/core'
import { PRIMARY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  wlViewTabs: {
    '& .Mui-selected': {
      color: PRIMARY_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: PRIMARY_COLORS[700]
    }
  }
}))
